import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Sign In or Create Account — Pal Stars" },
      { name: "description", content: "Sign in to Pal Stars to save your Palworld favorites, deck builds and TCG pack tracker across devices." },
      { property: "og:title", content: "Pal Stars — Sign In" },
      { property: "og:description", content: "Sign in to save favorites, decks and pack tracker across devices." },
      { property: "og:url", content: "https://palstars.com/auth" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex,follow" },
    ],
    links: [{ rel: "canonical", href: "https://palstars.com/auth" }],
  }),
});
